import React from 'react'

const BlogDetails = () => {
  return (
    <div>
      Blog edit or blog fetch single item.
    </div>
  )
}

export default BlogDetails
